import classNames from 'classnames';
import type { CSSProperties, FC } from 'react';
import styles from './index.less';

export const ActionCard: FC<{
  title: string;
  desc: string;
  style: CSSProperties;
  onClick?: () => void;
}> = (props) => {
  // props
  const { title, desc, style, onClick } = props;

  return (
    <section
      className={classNames(
        styles['ac-wrapper'],
        'flex flex-col justify-center w-64 px-4 rounded-lg cursor-pointer transition',
      )}
      style={style}
      onClick={onClick}
    >
      <p className="font-medium text-main">{title}</p>
      <p className="text-xs">{desc}</p>
    </section>
  );
};
